import {
  electricPurple000,
  electricPurple500,
  electricPurple600,
  monserratRegular,
  robotoRegular,
  scarpaGray50,
  scarpaGray500,
} from '@habitech/shared';
import styled from 'styled-components';

export const WrapperModal = styled.div`
  background: ${scarpaGray50};
  border-radius: 8px;
  .subtitle {
    font-family: ${robotoRegular};
    font-size: 14px;
    color: 'black';
  }
  .description {
    font-family: ${robotoRegular};
    color: ${scarpaGray500};
    font-size: 14px;
    line-height: 18px;
  }
  .modal-title {
    font-size: 16px;
    font-weight: bold;
    color: 'black';
    font-family: ${monserratRegular};
  }
  .btn-habi-white {
    font-size: 14px;
    height: 35px;
    font-family: 'Roboto';
    src: url(${robotoRegular}) format('truetype');
    background-color: ${electricPurple000};
    color: ${electricPurple600};
    border: 1px solid ${electricPurple000};
    border-radius: 8px;
  }
  .btn-habi-white:hover {
    color: ${electricPurple600};
    background-color: rgb(214, 243, 255);
    border: 1px solid rgb(214, 243, 255);
  }
  .btn-habi {
    height: 35px;
    font-size: 14px;
    font-family: 'Roboto';
    src: url(${robotoRegular}) format('truetype');
    background-color: ${electricPurple500};
    border: none;
    border-radius: 8px;
  }
  .btn-habi:hover {
    background-color: ${electricPurple600};
  }
  .bbxwrW.white .placeholder {
    font-size: 14px;
    color: black !important;
    background: white !important;
  }
  .cETOtc.white .placeholder {
    font-size: 14px;
    color: black !important;
    background: white !important;
  }
  .jkIYjY p {
    font-size: 14px;
  }
  textarea,
  textarea::placeholder,
  select {
    font-size: 14px;
    font-family: ${robotoRegular};
  }
`;
